import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const mLinkIdKey = "mLinkId";

export const useMLinkId = () => {
  const [searchParams] = useSearchParams();

  const setMLinkId = useCallback((value) => {
    localStorage.setItem(mLinkIdKey, value);
  }, []);

  const getMLinkId = useCallback(() => {
    let currentMLinkId = localStorage.getItem(mLinkIdKey);
    if (currentMLinkId) {
      currentMLinkId = parseInt(currentMLinkId);
    }
    return currentMLinkId;
  }, []);

  const init = useCallback(() => {
    const mLinkId = searchParams.get(mLinkIdKey);
    if (mLinkId) {
      setMLinkId(mLinkId);
    }
  }, [searchParams, setMLinkId]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    getMLinkId,
  };
};
